import { Star, MapPin } from "lucide-react";
import { Link } from "react-router-dom";


const centres = [
    { city: "Visakhapatnam", rating: 4.8, machines: 42, experts: 18 },
    { city: "Vijayawada", rating: 4.7, machines: 36, experts: 14 },
    { city: "Tirupati", rating: 4.6, machines: 29, experts: 12 },
    { city: "Kurnool", rating: 4.5, machines: 24, experts: 9 },
];

export default function ExploreCentres() {
    return (
        <section className="max-w-7xl mx-auto px-6 py-20" id="facilities">
            <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
                <div>
                    <span className="inline-block text-xs font-semibold bg-gray-100 rounded-full px-4 py-1.5 mb-5">
                        Innovation Centres
                    </span>
                    <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-3">
                        Explore APIC Centres
                    </h2>
                    <p className="text-gray-600">
                        Discover state-of-the-art prototyping facilities near you.
                    </p>
                </div>

                <Link
                    to="/facilities"
                    className="flex items-center gap-2 border border-gray-200 rounded-full px-5 py-2.5 text-sm font-semibold hover:bg-gray-50"
                >
                    View all centres →
                </Link>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {centres.map(({ city, rating, machines, experts }) => (
                    <div key={city} className="rounded-2xl overflow-hidden border border-gray-100 shadow-sm">
                        <div className="h-32 bg-gradient-to-br from-indigo-600 to-blue-500 relative p-4 flex flex-col justify-between">
                            <span className="self-end flex items-center gap-1 bg-white/20 backdrop-blur text-white text-xs font-semibold px-2.5 py-1 rounded-full">
                                <Star className="w-3 h-3 fill-white" /> {rating}
                            </span>
                            <span className="flex items-center gap-1 text-white text-sm font-medium">
                                <MapPin className="w-4 h-4" /> {city}
                            </span>
                        </div>
                        <div className="p-5">
                            <h3 className="font-bold text-gray-900 mb-2">APIC {city}</h3>
                            <p className="text-sm text-gray-500 mb-4">
                                <span className="font-semibold text-gray-700">{machines}</span> machines ·{" "}
                                <span className="font-semibold text-gray-700">{experts}</span> experts
                            </p>
                            <div className="flex items-center justify-between">
                                <span className="flex items-center gap-1.5 text-xs font-medium text-green-600">
                                    <span className="w-2 h-2 rounded-full bg-green-500" /> Available
                                </span>
                                <a href="#view" className="text-sm font-semibold text-indigo-600">
                                    View →
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}